<template>
    <div class="step-content-wrapper">
        <!-- MÉTODO DE PAGO -->
        <v-card variant="flat">
            <!-- TIPO DE PAGO-->
            <v-radio-group v-model="pagoEnvio.formaPago" inline>
                <v-radio
                    :value="1"
                    v-if="forma.usuario.pago_tipos.find((e) => e.id === 1)"
                >
                    <template v-slot:label>
                        <div>
                            {{ t("pago.enlinea.titulo") }}
                        </div>
                    </template>
                </v-radio>
                <v-radio
                    :value="2"
                    v-if="forma.usuario.pago_tipos.find((e) => e.id === 2)"
                >
                    <template v-slot:label>
                        <div>
                            {{ t("pago.deposito.titulo") }}
                            <!--{{ forma.usuario.pago_tipos[1] }}-->
                        </div>
                    </template>
                </v-radio>
                <v-radio
                    :value="3"
                    v-if="forma.usuario.pago_tipos.find((e) => e.id === 3)"
                >
                    <template v-slot:label>
                        <div>
                            {{ t("pago.link.titulo") }}
                            <!--{{ forma.usuario.pago_tipos[2] }}-->
                        </div>
                    </template>
                </v-radio>
            </v-radio-group>
            <!-- PAYPAL -->
            <v-card-text v-if="pagoEnvio.formaPago === 1">
                <!-- INSTRUCCIONES PARA PAGO EN LÍNEA-->
                <v-card class="background" flat>
                    <v-card-title class="text-text">{{
                        t("instrucciones")
                    }}</v-card-title>
                    <v-card-text class="text-text">
                        <ol class="ml-4">
                            <li v-html="t('pago.enlinea.paso1')"></li>
                            <li>{{ t("pago.enlinea.paso2") }}</li>
                            <ul class="ml-4">
                                <li>
                                    {{ t("pago.enlinea.opcion1") }}
                                </li>
                                <li>
                                    {{ t("pago.enlinea.opcion2") }}
                                </li>
                            </ul>
                            <li>{{ t("pago.enlinea.paso3") }}</li>
                        </ol>
                    </v-card-text>
                    <v-card-actions
                        class="pt-0 d-flex justify-lg-start justify-sm-center justify-center"
                    >
                        <boton-dinamico
                            :forma="{
                                tipo: 1,
                                archivo_pdf:
                                    'epm2026/terminos_de_uso/T&C_EXPO_PACK',
                            }"
                            :stand="stand"
                            origen="8"
                        >
                            <template v-slot="{ attrs, accion }">
                                <v-btn
                                    v-bind="{ ...size, ...attrs }"
                                    variant="text"
                                    color="primary"
                                    @click="accion"
                                    >{{ t("boton-ver") }}
                                    {{ t("pago.terminos") }}</v-btn
                                >
                            </template>
                        </boton-dinamico>
                    </v-card-actions>
                </v-card>
                <!-- ACEPTA TÉRMINOS Y CONDICIONES DE PAGO EN LÍNEA -->
                <v-card flat>
                    <v-card-text class="py-0">
                        <form-group :validator="v$.pagoEnvio.aceptaTerminos">
                            <v-checkbox
                                v-model="pagoEnvio.aceptaTerminos"
                                :false-value="null"
                                :true-value="1"
                                @change="aceptarTerminos"
                            >
                                <template #label>
                                    <div
                                        class="text-text"
                                        v-html="t('pago.aceptacion')"
                                    ></div>
                                </template>
                            </v-checkbox>
                        </form-group>
                    </v-card-text>
                    <v-card-actions
                        class="pl-4"
                        v-if="pagoEnvio.aceptaTerminos == 1"
                    >
                        <div v-if="errorPayPal" class="text-error text-body-2">
                            {{ t("pago.error-paypal") }}
                        </div>
                        <div v-else ref="paypal" style="width: 450px"></div>
                    </v-card-actions>
                </v-card>
            </v-card-text>
            <!-- DEPÓSITO Y/O TRANSFERENCIA-->
            <v-card-text class="pt-0" v-if="pagoEnvio.formaPago === 2">
                <!-- INSTRUCCIONES DEPÓSITO -->
                <v-card variant="flat">
                    <v-card-title class="text-text">{{
                        t("instrucciones")
                    }}</v-card-title>
                    <v-card-text class="text-text">
                        <ol class="ml-4">
                            <li v-html="t('pago.deposito.paso0')"></li>
                            <li v-html="t('pago.deposito.paso1-1')"></li>
                            <li v-html="t('pago.deposito.paso2')"></li>
                            <li>{{ t("pago.deposito.paso3") }}</li>
                            <li>{{ t("pago.deposito.paso4") }}</li>
                        </ol>
                    </v-card-text>
                </v-card>

                <v-card variant="flat">
                    <!-- DATOS BANCARIOS-->
                    <v-expansion-panels v-model="panelDatosDeposito" flat>
                        <v-expansion-panel bg-color="background">
                            <v-expansion-panel-title
                                class="text-body-2 text-text"
                            >
                                {{ t("pago.deposito.datos-bancarios") }}
                            </v-expansion-panel-title>
                            <v-expansion-panel-text bg-color="backgroundDarken">
                                <v-row>
                                    <v-col
                                        cols="12"
                                        lg="6"
                                        md="6"
                                        sm="12"
                                        xs="12"
                                    >
                                        <v-card
                                            class="white"
                                            flat
                                            v-if="
                                                datos_banco_nacional.length > 0
                                            "
                                            ><v-card-subtitle
                                                class="text-text font-weight-bold"
                                                >{{
                                                    t("pago.deposito-mxn")
                                                }}</v-card-subtitle
                                            >
                                            <v-divider></v-divider>
                                            <v-card-text>
                                                <v-row
                                                    v-for="(
                                                        item, i
                                                    ) in datos_banco_nacional"
                                                    :key="i"
                                                >
                                                    <v-col
                                                        cols="12"
                                                        lg="3"
                                                        md="3"
                                                        sm="12"
                                                        class="text-text"
                                                        >{{
                                                            item.etiqueta
                                                        }}</v-col
                                                    >
                                                    <v-col
                                                        cols="12"
                                                        lg="9"
                                                        md="9"
                                                        sm="12"
                                                        class="text-black font-weight-medium"
                                                        >{{ item.valor }}</v-col
                                                    >
                                                </v-row>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        lg="6"
                                        md="6"
                                        sm="12"
                                        xs="12"
                                    >
                                        <v-card
                                            class="white"
                                            flat
                                            v-if="
                                                datos_banco_extranjero.length >
                                                0
                                            "
                                            ><v-card-subtitle
                                                class="text-text font-weight-bold"
                                                >{{
                                                    t("pago.deposito-usd")
                                                }}</v-card-subtitle
                                            >

                                            <v-divider></v-divider>
                                            <v-card-text>
                                                <v-row
                                                    v-for="(
                                                        item, i
                                                    ) in datos_banco_extranjero"
                                                    :key="i"
                                                >
                                                    <v-col
                                                        cols="12"
                                                        lg="3"
                                                        md="3"
                                                        sm="12"
                                                        class="text-text"
                                                        >{{
                                                            item.etiqueta
                                                        }}</v-col
                                                    >
                                                    <v-col
                                                        cols="12"
                                                        lg="9"
                                                        md="9"
                                                        sm="12"
                                                        class="text-black font-weight-medium"
                                                        >{{ item.valor }}</v-col
                                                    >
                                                </v-row>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                    <!-- FILE INPUT RECIBO DEPÓSITO -->
                    <v-card-text
                        class="d-flex flex-column flex-sm-row justify-sm-start align-sm-start my-2"
                    >
                        <form-group :validator="v$.comprobante_pago">
                            <v-file-input
                                accept="image/jpeg, application/pdf"
                                @update:model-value="guardarComprobantePago"
                                v-model="comprobante_pago"
                                :label="t('pago.comprobante')"
                                :hint="t('indicio-archivo')"
                                persistent-hint
                                chips
                                variant="outlined"
                                density="compact"
                                class="mx-2"
                                multiple
                                show-size
                            >
                            </v-file-input>
                        </form-group>

                        <form-group-hint
                            :validator="v$.pagoEnvio.comprobantePago"
                        >
                            <listado-archivo
                                v-if="pagoEnvio.comprobantePago.length > 0"
                                v-model:listado="pagoEnvio.comprobantePago"
                                :titulo="t('pago.comprobante')"
                                tipo="comprobante_pago"
                                :borrar="1"
                                class="mx-2"
                            >
                            </listado-archivo>
                        </form-group-hint>
                    </v-card-text>
                </v-card>

                <!-- ACEPTA TÉRMINOS Y CONDICIONES DEPÓSITOS -->
                <v-card variant="flat">
                    <v-card-actions
                        class="d-flex justify-lg-start justify-sm-center justify-center"
                    >
                        <boton-dinamico
                            :forma="{
                                tipo: 1,
                                archivo_pdf:
                                    'epm2026/terminos_de_uso/T&C_EXPO_PACK',
                            }"
                            origen="8"
                            :stand="stand"
                        >
                            <template v-slot="{ attrs, accion }">
                                <v-btn
                                    v-bind="{ ...size, ...attrs }"
                                    variant="text"
                                    color="primary"
                                    @click="accion"
                                    >{{ t("boton-ver") }}
                                    {{ t("pago.terminos") }}</v-btn
                                >
                            </template>
                        </boton-dinamico>
                    </v-card-actions>
                    <v-card-text>
                        <form-group :validator="v$.pagoEnvio.aceptaTerminos">
                            <template #default="{ attrs }">
                                <v-checkbox
                                    v-bind="attrs"
                                    v-model="pagoEnvio.aceptaTerminos"
                                    :false-value="null"
                                    :true-value="1"
                                    @click="aceptarTerminos"
                                >
                                    <template v-slot:label>
                                        <div
                                            class="text-text"
                                            v-html="t('pago.aceptacion')"
                                        ></div>
                                    </template>
                                </v-checkbox>
                            </template>
                        </form-group>
                    </v-card-text>
                </v-card>
            </v-card-text>
            <!-- LINKS -->
            <v-card-text v-if="pagoEnvio.formaPago === 3">
                <!-- INSTRUCCIONES -->
                <v-card class="background mt-5" flat>
                    <v-card-title class="text-text">{{
                        t("pago.link.instrucciones")
                    }}</v-card-title>
                    <v-card-text class="text-text">
                        <ol>
                            <li v-html="t('pago.link.paso1')"></li>
                            <li v-html="t('pago.link.paso2')"></li>
                            <li>{{ t("pago.link.paso3") }}</li>
                            <li>{{ t("pago.link.paso4") }}</li>
                            <li v-html="t('pago.link.paso5')"></li>
                            <li v-html="t('pago.link.paso6')"></li>
                            <li>{{ t("pago.link.paso7") }}</li>
                            <li>{{ t("pago.link.paso8") }}</li>
                        </ol>
                    </v-card-text>
                    <v-card-actions
                        class="pt-0 d-flex justify-lg-start justify-sm-center justify-center"
                    >
                        <boton-dinamico
                            :forma="{
                                tipo: 1,
                                archivo_pdf:
                                    'epg2025/terminos_de_uso/T&C_EXPO_PACK',
                            }"
                            origen="8"
                            :stand="stand"
                        >
                            <template v-slot="{ attrs, accion }">
                                <v-btn
                                    v-bind="{ ...size, ...attrs }"
                                    variant="text"
                                    color="primary"
                                    @click="accion"
                                    >{{ t("pago.terminos") }}</v-btn
                                >
                            </template>
                        </boton-dinamico>
                    </v-card-actions>
                </v-card>

                <!-- ACEPTA TÉRMINOS Y CONDICIONES DEPÓSITOS -->
                <v-card flat>
                    <v-card-text class="py-0">
                        <form-group :validator="v$.pagoEnvio.aceptaTerminos">
                            <v-checkbox
                                v-model="pagoEnvio.aceptaTerminos"
                                :false-value="null"
                                :true-value="1"
                                @click="aceptarTerminos"
                            >
                                <template #label>
                                    <div
                                        class="text-text"
                                        v-html="t('pago.aceptacion')"
                                    ></div>
                                </template>
                            </v-checkbox>
                        </form-group>
                    </v-card-text>
                </v-card>
            </v-card-text>
        </v-card>
        <!-- BOTONES PAGO Y ENVÍO -->
        <v-card variant="flat">
            <v-card-actions class="d-flex flex-row justify-center">
                <v-btn
                    variant="outlined"
                    color="primary"
                    @click="regresar"
                    class="mx-2"
                    @click.prevent="redirect(route('home', stand.id))"
                >
                    {{ t("boton-regresar") }}
                </v-btn>

                <v-btn
                    color="primary"
                    variant="flat"
                    class="mx-2"
                    :loading="loading"
                    :disabled="loading"
                    @click="enviarOrden(null)"
                    v-if="pagoEnvio.formaPago != 1"
                >
                    {{ t("boton-enviarPedido") }}
                </v-btn>
            </v-card-actions></v-card
        >
        <dialogo-confirmacion ref="confirmacion" />
    </div>
    <v-overlay v-model="overlay" class="align-center justify-center">
        <v-progress-circular :size="50" indeterminate color="white" />
    </v-overlay>
</template>

<script setup>
import { ref, computed, watch, onBeforeMount, nextTick } from "vue";
import { useVuelidate } from "@vuelidate/core";
import {
    required,
    maxLength,
    helpers,
    requiredIf,
} from "@vuelidate/validators";
import { useI18n } from "vue-i18n";
import { router } from "@inertiajs/vue3";
import { useDisplay } from "vuetify";
import axios from "axios";
import { usePaypalLogger } from "../composables/usePaypalLogger";

const { t, n } = useI18n();
const { logPaypalError } = usePaypalLogger();
const { name: displayName } = useDisplay();

const props = defineProps({
    forma: Object,
    stand: Object,
    orden: Object,
    maniobra: Number,
    tipo: String,
});

const emit = defineEmits(["accionStepper"]);

// Access route helper (Ziggy)
const route = window.route;

const overlay = ref(false);
const panel = ref(null);
const abrev_moneda = ref(null);
const panelDatosDeposito = ref(null);
const paypal = ref(null);
const confirmacion = ref(null);

const pagoEnvio = ref({
    formaPago: props.orden != null ? props.orden.forma_pago : null,
    comprobantePago: props.orden != null ? props.orden.comprobante_pago : [],
    aceptaTerminos: null,
});
const comprobante_pago = ref(null);
const datos_banco_nacional = ref(props.forma.usuario.usuario_bancos);
const datos_banco_extranjero = ref(props.forma.usuario.usuario_bancos2);
const errorPayPal = ref(false);
const loader = ref(null);
const loading = ref(false);
const constancia = ref(
    props.orden.dato_fiscal != null ? props.orden.dato_fiscal.constancia : []
);

const redirect = (url) => {
    router.get(url, {}, { preserveState: true });
};

onBeforeMount(() => {
    if (props.orden !== null) {
        abrev_moneda.value =
            props.orden.moneda == 1
                ? t("abreviatura-pesos")
                : t("abreviatura-dolares");
    }
});

watch(loader, (val) => {
    if (!val) return;
    setTimeout(() => (overlay.value = false), 4000);
});

watch(
    () => pagoEnvio.value.formaPago,
    (newValue, oldValue) => {
        // Only call actualizarFormaPago if the value actually changed and it's not the initial load
        if (newValue !== oldValue && oldValue !== undefined) {
            actualizarFormaPago();
        }
    }
);

const size = computed(() => {
    const sizes = {
        xs: "x-small",
        sm: "small",
        lg: "large",
        xl: "x-large",
    };
    return sizes[displayName.value] ? { size: sizes[displayName.value] } : {};
});

function actualizarFormaPago() {
    // Determinar qué ruta usar basándose en si existe orden o es tipo maniobra
    const isManiobra =
        props.tipo === "maniobra" || (!props.orden && props.tipo);
    const routeName = isManiobra
        ? "reglas.maniobras.forma-pago"
        : "forma-dinamica-b.forma-pago";

    const routeParams = isManiobra
        ? {
              stand: props.stand.id,
              forma: props.forma.parametros,
          }
        : {
              stand: props.stand.id,
              forma: props.forma.parametros,
              orden: props.orden.id,
          };

    router.post(
        route(routeName, routeParams),
        {
            forma_pago: pagoEnvio.value.formaPago,
        },
        {
            preserveScroll: true,
            onSuccess: (page) => {
                // Actualizar el valor desde la respuesta o props
                if (props.orden) {
                    pagoEnvio.value.formaPago = props.orden.forma_pago;
                    pagoEnvio.value.comprobantePago =
                        props.orden.comprobante_pago;
                }
                pagoEnvio.value.aceptaTerminos = null;
            },
        }
    );
}

function aceptarTerminos() {
    if (pagoEnvio.value.formaPago == 1) {
        if (pagoEnvio.value.aceptaTerminos == 1) {
            // Validar que paypal_client_id existe y no es null
            if (
                !props.forma.usuario.paypal_client_id ||
                props.forma.usuario.paypal_client_id === null ||
                props.forma.usuario.paypal_client_id.trim() === ""
            ) {
                console.error("PayPal Client ID no está configurado");
                errorPayPal.value = true;
                return;
            }

            // Verificar si el script de PayPal ya está cargado
            const existingScript = document.querySelector(
                'script[src*="paypal.com/sdk/js"]'
            );
            if (existingScript) {
                // Si ya existe, solo ejecutar setLoaded
                if (window.paypal) {
                    setLoaded();
                } else {
                    existingScript.addEventListener("load", setLoaded);
                }
                return;
            }

            const script = document.createElement("script");
            script.src =
                "https://www.paypal.com/sdk/js?client-id=" +
                props.forma.usuario.paypal_client_id +
                "&currency=" +
                abrev_moneda.value +
                "&locale=" +
                t("locale") +
                "&components=buttons,hosted-fields" +
                "&enable-funding=card" +
                "&intent=capture" +
                "&vault=false";
            script.addEventListener("load", setLoaded);
            script.addEventListener("error", () => {
                console.error("Error al cargar el SDK de PayPal");
                errorPayPal.value = true;
            });
            document.body.appendChild(script);
        }
    }
}

function setLoaded() {
    // Validar que el SDK de PayPal esté disponible
    if (!window.paypal) {
        console.error("El SDK de PayPal no está disponible");
        errorPayPal.value = true;
        return;
    }
    let descripcion = "";
    descripcion = props.forma.evento.slug;

    try {
        window.paypal
            .Buttons({
                style: {
                    layout: "vertical",
                    color: "gold",
                    shape: "rect",
                    label: "paypal",
                },
                funding: {
                    allowed: [
                        window.paypal.FUNDING.CARD,
                        window.paypal.FUNDING.PAYPAL,
                    ],
                    disallowed: [
                        window.paypal.FUNDING.CREDIT,
                        window.paypal.FUNDING.VENMO,
                        window.paypal.FUNDING.MERCADOPAGO,
                    ],
                },
                createOrder: (data, actions) => {
                    return actions.order.create({
                        purchase_units: [
                            {
                                description: descripcion,
                                amount: {
                                    currency_code: abrev_moneda.value,
                                    value: props.orden.total,
                                },
                            },
                        ],
                        application_context: {
                            shipping_preference: "NO_SHIPPING",
                        },
                    });
                },
                onApprove: async (data, actions) => {
                    overlay.value = true;
                    try {
                        const order = await actions.order.capture();
                        let transaction =
                            order.purchase_units[0].payments.captures[0];
                        if (
                            transaction &&
                            transaction.status &&
                            transaction.status !== "COMPLETED"
                        ) {
                            logPaypalError(
                                { capture: transaction, order },
                                {
                                    ordenId: props.orden?.id ?? undefined,
                                    maniobraId: props.maniobra ?? undefined,
                                    component: "GestorPagos",
                                    message: "Capture no COMPLETED",
                                    paypalClientId:
                                        props.forma?.usuario?.paypal_client_id ||
                                        undefined,
                                }
                            );
                        }
                        let payment_id = transaction.id;
                        enviarOrden(payment_id);
                    } catch (captureErr) {
                        logPaypalError(captureErr, {
                            ordenId: props.orden?.id ?? undefined,
                            maniobraId: props.maniobra ?? undefined,
                            component: "GestorPagos",
                            paypalClientId:
                                props.forma?.usuario?.paypal_client_id ||
                                undefined,
                        });
                        errorPayPal.value = true;
                        overlay.value = false;
                    }
                },
                onCancel: (data) => {
                    // Payment cancelled by user
                },
                onError: (err) => {
                    console.error("PayPal error:", err);
                    logPaypalError(err, {
                        ordenId: props.orden?.id ?? undefined,
                        maniobraId: props.maniobra ?? undefined,
                        component: "GestorPagos",
                        paypalClientId:
                            props.forma?.usuario?.paypal_client_id || undefined,
                    });
                    errorPayPal.value = true;
                },
            })
            .render(paypal.value);
    } catch (error) {
        console.error("Error al inicializar los botones de PayPal:", error);
        logPaypalError(error, {
            ordenId: props.orden?.id ?? undefined,
            maniobraId: props.maniobra ?? undefined,
            component: "GestorPagos",
            paypalClientId:
                props.forma?.usuario?.paypal_client_id || undefined,
        });
        errorPayPal.value = true;
    }
}

function guardarComprobantePago(archivos) {
    // Verificar que haya archivos seleccionados
    if (!archivos || archivos.length === 0) {
        return false;
    }

    // Asignar a la variable para que la validación funcione
    comprobante_pago.value = archivos;

    v$.value.comprobante_pago.$touch();

    if (v$.value.comprobante_pago.$invalid) {
        return false;
    }

    let formData = new FormData();
    formData.append("key", "comprobante_pago");

    for (let archivo of archivos) {
        formData.append("comprobante_pago[]", archivo, archivo.name);
    }

    axios
        .post(
            route("reglas.maniobras.guardar-archivos", props.maniobra),
            formData
        )
        .then((response) => {
            console.log("comprobantePago", response.data);
            pagoEnvio.value.comprobantePago = response.data;

            comprobante_pago.value = [];
        })
        .catch((error) => {
            console.error("Error al guardar comprobante:", error);
        });
}

async function enviarOrden(paymentId) {
    v$.value.pagoEnvio.$touch();
    if (v$.value.pagoEnvio.$invalid) {
        console.log(
            "enviarOrden v$.value.pagoEnvio.$invalid",
            v$.value.pagoEnvio.$invalid
        );
        return false;
    }

    // Solo mostrar diálogo de confirmación si NO es pago de PayPal
    // (paymentId es null cuando es depósito/transferencia)
    if (!paymentId) {
        // Mostrar diálogo de confirmación SIN activar loading aún
        const confirmado = await confirmacion.value.abrir(
            t("dialogo-confirmacion.titulo"),
            t("dialogo-confirmacion.enviar-pedido")
        );

        // Si el usuario no confirmó, detener la ejecución
        if (!confirmado) {
            return false;
        }

        // Usuario confirmó, AHORA SÍ activar loading
        loading.value = true;
    }

    // Si confirmó (o es pago de PayPal), continuar con el envío
    if (pagoEnvio.value.formaPago != 1) {
        loader.value = "loading";
    }

    router.post(
        route("reglas.maniobras.enviar-pago-adicionales", {
            stand: props.stand.id,
            forma: props.forma.parametros,
        }),
        {
            payment_id: paymentId,
        },
        {
            replace: true,
            onError: () => {
                // Desactivar loading si hay error
                loading.value = false;
                overlay.value = false;
            },
        }
    );
}

function regresar() {
    emit("accionStepper", 5);
}

const rules = computed(() => ({
    pagoEnvio: {
        formaPago: { required },
        aceptaTerminos: { required },
        comprobantePago: {
            required: helpers.withMessage(
                () => t("validations.required"),
                requiredIf(() => pagoEnvio.value.formaPago === 2)
            ),
        },
    },
    comprobante_pago: {
        maxFileSize: (value) => {
            if (!value) return true;
            const maxSize = 2000000;
            let arreglo = value.map((archivo) => {
                if (archivo.size > maxSize) return 0;
                return 1;
            });
            return arreglo.includes(0) ? false : true;
        },
    },
}));

const v$ = useVuelidate(rules, {
    pagoEnvio,
    comprobante_pago,
});
</script>

<style scoped>
.step-content-wrapper {
    max-width: 100%;
    margin: 0 auto;
}

@media (max-width: 960px) {
    .step-content-wrapper {
        max-width: 100%;
    }
}

.custom-hover:hover {
    background-color: rgba(var(--v-theme-primary), 0.1);
}

.custom-loader {
    animation: loader 1s infinite;
    display: flex;
}
@-moz-keyframes loader {
    from {
        transform: rotate(0);
    }
    to {
        transform: rotate(360deg);
    }
}
@-webkit-keyframes loader {
    from {
        transform: rotate(0);
    }
    to {
        transform: rotate(360deg);
    }
}
@-o-keyframes loader {
    from {
        transform: rotate(0);
    }
    to {
        transform: rotate(360deg);
    }
}
@keyframes loader {
    from {
        transform: rotate(0);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>
